module.exports = __webpack_public_path__ + "static/miu-en-4c51a2f021f02de1a9fe70536e49be88.svg";